module.exports = __webpack_public_path__ + "img/logo_color.346d7318.svg";